import { CxEvent } from '@spartacus/core';

export class GtmGgCartRemoveEntrySuccessEvent extends CxEvent {
  event?: string;
  productId?: string;
  ecommerce?: {
    currencyCode?: string;
    remove?: {
      products?: {
        name?: string;
        id?: string;
        price?: string | number;
        quantity?: string | number;
      }[];
    };
  };
}
